import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[color:var(--charcoal)] text-[color:var(--bg-base)] pt-24 pb-10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-[color:var(--bg-base)]/15">
          <div className="md:col-span-5">
            <p className="overline" style={{ color: "var(--gold)" }}>— The Foundation Edit</p>
            <h3 className="mt-4 font-serif-display text-3xl leading-snug">
              Business setup &amp; systems.
            </h3>
          </div>
          <div className="md:col-span-3 md:col-start-7">
            <p className="overline mb-4" style={{ color: "var(--bg-base)" }}>Navigate</p>
            <ul className="space-y-3 text-sm text-[color:var(--bg-base)]/75">
              <li><a href="#about" className="hover:text-[color:var(--gold)] transition-colors">About</a></li>
              <li><a href="#packages" className="hover:text-[color:var(--gold)] transition-colors">Packages</a></li>
              <li><a href="#process" className="hover:text-[color:var(--gold)] transition-colors">Process</a></li>
              <li><a href="#enquire" className="hover:text-[color:var(--gold)] transition-colors">Enquire</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-4" style={{ color: "var(--bg-base)" }}>Contact</p>
            <ul className="space-y-3 text-sm text-[color:var(--bg-base)]/75">
              <li className="flex items-center gap-2"><Mail size={14} strokeWidth={1} /> info@thefoundationedit.co.uk</li>
              <li>
                <a href="https://www.instagram.com/thefoundationedituk?igsh=ajJyZGNoZGZlbGNk" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-2 hover:text-[color:var(--gold)] transition-colors">
                  <Instagram size={14} strokeWidth={1} /> @thefoundationedit.uk
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-12 pb-6">
          <h2 className="mega-type text-[15vw] sm:text-[12vw] leading-none text-[color:var(--bg-base)] select-none">
            The Foundation Edit
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-6 pt-8 border-t border-[color:var(--bg-base)]/15">
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-xs tracking-[0.18em] uppercase text-[color:var(--bg-base)]/60">
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[color:var(--gold)] transition-colors">Terms &amp; Conditions</Link>
            <Link to="/refund-policy" data-testid="footer-refund-link" className="hover:text-[color:var(--gold)] transition-colors">Refund Policy</Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[color:var(--gold)] transition-colors">Privacy Policy</Link>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-[color:var(--bg-base)]/50 tracking-wider mt-8">
          <p>© {new Date().getFullYear()} The Foundation Edit. All rights reserved.</p>
          <p className="italic font-serif-display">Refined, structured, considered.</p>
        </div>
      </div>
    </footer>
  );
}
